export default __webpack_public_path__ + "static/media/SG4.d146c58d.webp";